class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    gsap.registerPlugin();
    // 要素取得
    const mvMask = document.querySelector('.js-mv-mask');
    const header = document.querySelector('.js-header');
    const loop = document.querySelector('.js-mv-loop');
    const mv = document.querySelector('.js-mv');
    const drawer = document.querySelector('.js-drawer');
    
    const imgs = document.querySelectorAll('.js-mv-img');
    const copies = document.querySelectorAll('.js-mv-copy');
  

    // =========================
    // 初期状態
    // =========================
    // gsap.set([
    //   loadingTtl,
    //   loadingImg,
    // ], { opacity: 0 });

    gsap.set([
      mvMask,
      imgs,
      copies
    ], { opacity: 0 });

    const fadeTargets = window.innerWidth >= 768
    ? [header, drawer, loop]
    : [header, drawer, loop];
  
    gsap.set(fadeTargets, {
      opacity: 0
    });

    // =========================
    // タイムライン
    // =========================

    // ローディング以外の元々のTOPアニメーション
    // ※ paused にして、ローディング完了後に再生する
    const tl = gsap.timeline({
      paused: true
    });

    // =========================
    // 新ローディング
    // =========================
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    const rippleSize = isMobile ? '40rem' : '64rem';

    gsap.set('.js-exclamation', {
      opacity: 0,
    });

    gsap.set('.js-exclamation .top', {
      opacity: 1,
      y: 0,
      scaleY: 1
    });

    gsap.set('.js-exclamation .sub', {
      opacity: 1,
      y: '1.6rem',
      scale: 1
    });

    gsap.set('.js-loading-bg-2', {
      opacity: 0
    });

    gsap.set('.ripple', {
      width: '2rem',
      height: '2rem',
      opacity: 0
    });

    gsap.set('.js-loading-bg-3', {
      opacity: 0
    });

    gsap.set('.js-next-img', {
      opacity: 0
    });

    gsap.set('.splash', {
      xPercent: -50,
      yPercent: -50,
      x: 0,
      y: 0,
      scale: .5,
      opacity: 0
    });

    gsap.set('.js-third-area', {
      opacity: 0
    });

    gsap.set('.js-object-main', {
      opacity: 0,
    });

    gsap.set('.js-last-area', {
      opacity: 1
    });

    gsap.set('.js-last-ttl', {
      opacity: 0,
      visibility: 'visible'
    });

    const loadingTl = gsap.timeline({
      defaults: {
        ease: 'power2.out'
      }
    });

    loadingTl.to('.js-exclamation', {
      opacity: 1,
      ease: 'power2.out'
    });

    // しばらく表示
    loadingTl.to({}, {
      duration: .75
    });

    loadingTl.to('.js-exclamation .top', {
      y: '-8rem',
      scaleY: .85,
      opacity: 0,
      duration: 1.0,
      ease: 'power2.out'
    }, .4);

    loadingTl.to('.js-exclamation .sub', {
      y: '25rem',
      duration: .6,
      ease: 'power2.in'
    }, .4);
    
    loadingTl.to('.js-exclamation .sub', {
      y: '8rem',
      duration: .9,
      ease: 'power3.out'
    }, 1.0);

    // 着水タイミング
    const splashStart = 1;

    loadingTl.to('.js-loading-bg-2', {
      opacity: .8,
      duration: .55,
      ease: 'power2.out'
    }, splashStart);

    loadingTl.to('.js-loading-bg-2', {
      opacity: 1,
      duration: 1.0,
      ease: 'power2.out'
    }, splashStart + .85);

    // 着水後、丸も飛沫と同じ色にする
    loadingTl.set('.js-exclamation .sub', {
      backgroundColor: 'rgba(255,255,255,.65)'
    }, splashStart);

    loadingTl.to('.js-exclamation .sub', {
      duration: 2.0,
      ease: 'power2.out',
      keyframes: [
        {
          opacity: .75,
          scale: 1,
          duration: .35
        },
        {
          opacity: .55,
          scale: .95,
          duration: .55
        },
        {
          opacity: 0,
          scale: .85,
          duration: .77
        }
      ]
    }, splashStart);

    loadingTl.to('.ripple:nth-child(1)', {
      width: rippleSize,
      height: rippleSize,
      opacity: 0,
      duration: 2.0,
      ease: 'power2.out',
      keyframes: [
        { opacity: .75, duration: .35 },
        { opacity: .45, duration: .55 },
        { opacity: 0, duration: 1.1 }
      ]
    }, splashStart);

    loadingTl.to('.ripple:nth-child(2)', {
      width: rippleSize,
      height: rippleSize,
      opacity: 0,
      duration: 2.0,
      ease: 'power2.out',
      keyframes: [
        { opacity: .65, duration: .35 },
        { opacity: .35, duration: .55 },
        { opacity: 0, duration: 1.1 }
      ]
    }, splashStart + .3);

    const splashData = isMobile
      ? [
        { el: '.splash:nth-child(1)', x: '-18rem', y: '-8rem',  scale: 1.25, delay: 0 },
        { el: '.splash:nth-child(2)', x: '-12rem', y: '-10rem', scale: 1.2,  delay: .03 },
        { el: '.splash:nth-child(3)', x: '-6rem',  y: '-7rem',  scale: 1.1,  delay: .05 },
        { el: '.splash:nth-child(4)', x: '0rem',   y: '-12rem', scale: 1.25, delay: .02 },
        { el: '.splash:nth-child(5)', x: '6rem',   y: '-7rem',  scale: 1.1,  delay: .07 },
        { el: '.splash:nth-child(6)', x: '12rem',  y: '-10rem', scale: 1.2,  delay: .05 },
        { el: '.splash:nth-child(7)', x: '18rem',  y: '-8rem',  scale: 1.25, delay: .01 },
        { el: '.splash:nth-child(8)', x: '3rem',   y: '-13rem', scale: 1.15, delay: .08 }
      ]
      : [
        { el: '.splash:nth-child(1)', x: '-30rem', y: '-12rem', scale: 1.25, delay: 0 },
        { el: '.splash:nth-child(2)', x: '-20rem', y: '-16rem', scale: 1.2,  delay: .03 },
        { el: '.splash:nth-child(3)', x: '-9rem',  y: '-11rem', scale: 1.1,  delay: .05 },
        { el: '.splash:nth-child(4)', x: '0rem',   y: '-18rem', scale: 1.25, delay: .02 },
        { el: '.splash:nth-child(5)', x: '9rem',   y: '-11rem', scale: 1.1,  delay: .07 },
        { el: '.splash:nth-child(6)', x: '20rem',  y: '-16rem', scale: 1.2,  delay: .05 },
        { el: '.splash:nth-child(7)', x: '30rem',  y: '-12rem', scale: 1.25, delay: .01 },
        { el: '.splash:nth-child(8)', x: '4rem',   y: '-20rem', scale: 1.15, delay: .08 }
      ];

    splashData.forEach((item) => {
      loadingTl.to(item.el, {
        x: item.x,
        y: item.y,
        scale: item.scale,
        duration: 2.0,
        ease: 'power2.out',
        keyframes: [
          {
            opacity: .75,
            duration: .35
          },
          {
            opacity: .55,
            duration: .55
          },
          {
            opacity: 0,
            duration: 1.1
          }
        ]
      }, splashStart + item.delay);
    });

    const objectStart = splashStart + 1.25;

    // js-object：水面位置から表示
    loadingTl.to('.js-third-area', {
      opacity: 1,
      duration: .01
    }, objectStart);

    // 親要素を必ず表示状態に戻す
    loadingTl.set('.js-object', {
      opacity: 1,
      y: 0
    }, objectStart);

    // オーバル本体の初期化
    loadingTl.set('.js-object-main', {
      opacity: 0,
      y: '10rem',
      scaleY: 0.9,
      transformOrigin: 'center bottom'
    }, objectStart);

    // 出現位置から止まらず、ゆっくり一定速度で上昇
    loadingTl.to('.js-object-main', {
      y: '-52%',
      scaleY: 1,
      duration: 5.4,
      ease: 'none'
    }, objectStart);

    // 出始めはじわっとフェードイン
    loadingTl.to('.js-object-main', {
      opacity: 0.75,
      duration: 2.4,
      ease: 'power2.out'
    }, objectStart);

    loadingTl.to('.js-object-main', {
      opacity: 0,
      duration: 2.2,
      ease: 'power1.out'
    }, objectStart + 1.0);

    loadingTl.to('.js-object', {
      opacity: 0,
      duration: 2.2,
      ease: 'power1.out'
    }, objectStart + 1.0);

    // オブジェクト全体も同じ速度で上昇
    loadingTl.to('.js-object', {
      y: '-45%',
      duration: 5.0,
      ease: 'none'
    }, objectStart);

    loadingTl.to('.js-last-ttl', {
      opacity: 0.5,
      duration: 0.9,
      ease: 'power2.out'
    }, objectStart + 1.35);

    loadingTl.to('.js-last-ttl', {
      opacity: 1,
      duration: 1,
      ease: 'power2.out'
    }, objectStart + 1.85);

    loadingTl.to('.js-last-ttl', {
      opacity: 0,
      duration: 0.5,
      ease: 'power2.out'
    }, objectStart + 3.3);
    
    loadingTl.set('.js-last-ttl', {
      visibility: 'hidden'
    }, objectStart + 3.9);

    loadingTl.to('.js-loading-bg-3', {
      opacity: 1,
      duration: 1.0,
      ease: 'power2.out'
    }, objectStart + 3.6);
    
    loadingTl.to('.js-loading-bg-3', {
      opacity: 0,
      duration: 1.0,
      ease: 'power2.out'
    }, objectStart + 4.1);
    
    loadingTl.to('.js-next-img', {
      opacity: 1,
      duration: 1.0,
      ease: 'power2.out'
    }, objectStart + 4.1);

    // js-next-imgの表示時間を長めに取る
    loadingTl.to({}, {
      duration: 3.6
    }, objectStart + 5.9);

    // p-loadingを消す前に、裏側のMV画像を先に表示しておく
    loadingTl.set('.js-mv-img[data-slide="1"]', {
      opacity: 1
    }, objectStart + 7.0);

    // ローディング全体を消す
    loadingTl.to('.p-loading', {
      opacity: 0,
      duration: 0.8,
      ease: 'power2.out',
      onStart: () => {
        tl.play();
      },
      onComplete: () => {
        gsap.set('.p-loading', {
          display: 'none'
        });
      }
    }, objectStart + 7.1);
    // 速度は提供コードのまま
    loadingTl.timeScale(0.85);


    // =========================
    // ここから下は元々のtop.jsのローディング後処理
    // =========================

    tl.to(mvMask, {
      opacity: 1,
      duration: 0.5
    });

    tl.to('.js-mv-copy[data-slide="1"]', {
      opacity: 1,
      duration: 0.8
    });

    const target = window.innerWidth >= 768
      ? [header, drawer, loop]
      : [header, drawer, loop];

    tl.to(target, {
      opacity: 1,
      duration: 1
    });

    tl.add(() => {
      if (mvLoopSwiper) {
        mvLoopSwiper.update();

        if (mvLoopSwiper.autoplay) {
          mvLoopSwiper.autoplay.start();
        }
      }
    });

    tl.to({}, { duration: 5 });

    tl.to('.js-mv-copy[data-slide="1"]', {
      opacity: 1,
      duration: 0.8,
      onComplete: () => {
        gsap.set('.js-mv-copy[data-slide="1"]', {
          clearProps: "opacity"
        });
      }
    });

    tl.add(() => {
      startSlider(1);
    });

    const slides = [1, 2, 3];
    let current = 0;
    let mvTimer = null;
    let isMvStopped = false;
    
    function setSlide(index) {
      current = (index + slides.length) % slides.length;
    
      const slideNum = slides[current];
    
      imgs.forEach(el => {
        el.classList.toggle(
          'is-active',
          Number(el.dataset.slide) === slideNum
        );
      });
    
      copies.forEach(el => {
        el.classList.toggle(
          'is-active',
          Number(el.dataset.slide) === slideNum
        );
      });
    
      // slide3 の時だけ mask を消す
      if (slideNum === 3) {
        gsap.to(mvMask, {
          opacity: 0,
          duration: 0.6
        });
      } else {
        gsap.to(mvMask, {
          opacity: 1,
          duration: 0.6
        });
      }
    }
    
    function clearMvTimer() {
      if (mvTimer) {
        clearInterval(mvTimer);
        mvTimer = null;
      }
    }
    
    function startMvTimer() {
      clearMvTimer();
    
      if (isMvStopped) return;
    
      mvTimer = setInterval(() => {
        setSlide(current + 1);
      }, 6000);
    }
    
    function nextMvSlide() {
      setSlide(current + 1);
      if (!isMvStopped) {
        startMvTimer();
      }
    }
    
    function prevMvSlide() {
      setSlide(current - 1);
      if (!isMvStopped) {
        startMvTimer();
      }
    }

    function updateMvControlIcon() {
      if (!mvStopIcon || !mvStartIcon) return;
    
      if (isMvStopped) {
        mvStopIcon.classList.remove('is-active');
        mvStartIcon.classList.add('is-active');
      } else {
        mvStopIcon.classList.add('is-active');
        mvStartIcon.classList.remove('is-active');
      }
    }
    
    function stopMvSlide() {
      isMvStopped = true;
      clearMvTimer();
      updateMvControlIcon();
    }
    
    function restartMvSlide() {
      isMvStopped = false;
      startMvTimer();
      updateMvControlIcon();
    }    
    
    function startSlider(startIndex = 0) {
      current = startIndex;
    
      // 初期の gsap.set opacity:0 が残っていると、
      // 2枚目以降に is-active を付けても表示されないため解除
      gsap.set(imgs, {
        clearProps: 'opacity'
      });
    
      gsap.set(copies, {
        clearProps: 'opacity'
      });
    
      setSlide(current);
      startMvTimer();
      updateMvControlIcon();
    }
    
    const mvPrev = document.querySelector('.js-mv-prev');
    const mvNext = document.querySelector('.js-mv-next');
    const mvStop = document.querySelector('.js-mv-stop');
    const mvStopIcon = document.querySelector('.js-mv-stop-icon');
    const mvStartIcon = document.querySelector('.js-mv-start-icon');

    if (mvPrev) {
      mvPrev.addEventListener('click', (e) => {
        e.preventDefault();
        prevMvSlide();
      });
    }
    
    if (mvNext) {
      mvNext.addEventListener('click', (e) => {
        e.preventDefault();
        nextMvSlide();
      });
    }
    
    if (mvStop) {
      mvStop.addEventListener('click', (e) => {
        e.preventDefault();
    
        if (isMvStopped) {
          restartMvSlide();
        } else {
          stopMvSlide();
        }
      });
    }
    
    let mvLoopSwiper = null;

    const swiperEl2 = document.querySelector('.js-mv-loop');
    if (swiperEl2) {
      mvLoopSwiper = new Swiper(swiperEl2, {
        loop: true,
        slidesPerView: "auto",
        spaceBetween: 0,
        speed: 9000,
        allowTouchMove: false,
        simulateTouch: false,
        freeMode: true,
        freeModeMomentum: false,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        },
        loopAdditionalSlides: 3,
        breakpoints: {
          768: {
            slidesPerView: "auto",
            spaceBetween: 40,
            speed: 10000,
          },
        },
      });
    }

    let interviewSwiper = null;

    function initInterviewSwiper() {
      const el = document.querySelector('.js-interview-swiper');
      if (!el) return;
    
      const isSP = window.matchMedia('(max-width: 767px)').matches;
    
      if (isSP && !interviewSwiper) {
        interviewSwiper = new Swiper(el, {
          loop: false,
          slidesPerView: 1.4,
          spaceBetween: 20,
          speed: 1000,
    
          on: {
            slideChange(swiper) {
              updateIndicator(swiper);
            }
          }
        });
    
        // 初期位置
        updateIndicator(interviewSwiper);
      }
    
      if (!isSP && interviewSwiper) {
        interviewSwiper.destroy(true, true);
        interviewSwiper = null;
      }
    }
    
    function updateIndicator(swiper) {
      const current = swiper.el.querySelector('.swiper-current');
      const pagination = swiper.el.querySelector('.swiper-pagination');
      if (!current || !pagination) return;
    
      const total = swiper.slides.length;
      const index = swiper.activeIndex;
    
      const paginationWidth = pagination.offsetWidth;
      const currentWidth = paginationWidth / total;
    
      // 位置 = インデックス × 1コマ分
      const x = currentWidth * index;
    
      current.style.transform = `translateX(${x}px)`;
    }
    // 初回
    initInterviewSwiper();
    
    // リサイズ
    window.addEventListener('resize', initInterviewSwiper);
  }
}
